import {
  DocumentProperties,
  ParcelDocumentCreation,
} from '@/domain/entities/ParcelDocument';
import parcelDocumentsRepository from '@/domain/repository/DocumentsRepository';

export const getParcelDocuments = async (parcelUuid: string): Promise<Array<DocumentProperties>> => {
  try {
    return parcelDocumentsRepository.getParcelDocuments(parcelUuid);
  } catch (error) {
    console.error('Error fetching documents', error);
    return [];
  }
};

export const createParcelDocument = async (parcelDocument: ParcelDocumentCreation): Promise<void> => {
  try {
    if (!parcelDocument.file) return;
    const createdDocument = await parcelDocumentsRepository.createParcelDocument({
      parcelUuid: parcelDocument.parcelUuid,
      description: parcelDocument.description
    });
    if (createdDocument) {
      await _createDocumentData(createdDocument.uuid, parcelDocument.file);
    }
  } catch (error) {
    console.error('Error creating document', error);
    return undefined;
  }
};

export const deleteParcelDocument = async (documentUuid: string): Promise<void | undefined> => {
  try {
    return parcelDocumentsRepository.deleteParcelDocument(documentUuid);
  } catch (error) {
    console.error('Error deleting document', error);
    return undefined;
  }
};

export const getDocumentData = async (documentUuid: string): Promise<Blob> => {
  try {
    return parcelDocumentsRepository.getDocumentData(documentUuid);
  } catch (error) {
    console.error('Error fetching document data', error);
    throw error;
  }
};

const _createDocumentData = async (documentUuid: string, file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  await parcelDocumentsRepository.createDocumentData(documentUuid, formData);
};